<template>
  <div class="aco-grid">
    <div class="aco-info-box">
      <user-filter/>
    </div>
    <div class="aco-details-box">
      <user-list/>
    </div>
  </div>
</template>

<script>
  import UserFilter from './UserFilter'
  import UserList from './UserList'

  export default {
    components: {
      userFilter: UserFilter,
      userList: UserList
    }
  }
</script>

